import React, { useState, useEffect } from 'react';
import { rowStyles } from './ReportPhotos.styles';
import Image, { ImageList } from 'global/components/image';
import ScoreIcon from 'global/components/ScoreIcon';
import { first, get, set } from 'global/lib/lodash';
import clsx from 'clsx';
import moment from 'moment';
import { getRealmIcon } from 'global/components/droprealms';
import { Icon, Button } from '@mui/material';
import colors from 'global/styles/colors';
import useRetrieveData from 'global/hooks/useRetrieveData';
import sendData from 'redux/actions/sendData';
import { Loader, useScreen } from 'global/styles';
import CreateModal from '../Highlights/create';
import { getDisplayValue } from 'global/utils/getDisplayScore';
import { getRealmName } from 'global/utils';
import { Media } from '../../../global/components/Media';

const mergeKeysIntoRealm = (obj) => {
  Object.keys(obj).map((k) => {
    if (k.indexOf('realm_') > -1) {
      const key = k.split('_')[1];
      set(obj, ['realm', key], obj[k]);
    } else if (k.indexOf('_realm') > -1) {
      const key = k.split('_')[0];
      set(obj, ['realm', key], obj[k]);
    }
  });
};

const Photo = (props) => {
  const { collectionName, scorecard_score, onClick, selectImage, imageSize, imageSel, canSelect } = props;
  const classes = rowStyles({ imageSize });

  const renderData = () => {
    let icon = null,
      title = null,
      subtitle = null;

    if (collectionName === 'scorecard-score-images') {
      icon = <ScoreIcon {...scorecard_score} />;
      title = `${get(props, 'superset.name')}`;
      subtitle = `${get(props, 'checklist.name', 'N/A')}`;
    } else if (collectionName === 'report-section-site-images' || collectionName === 'report-section-bp-images') {
      if (collectionName === 'report-section-bp-images' || get(props, 'quality_type') === 2) {
        icon = <Icon style={{ color: colors.success }}>thumb_up</Icon>;
      } else {
        icon = <Icon style={{ color: colors.danger }}>thumb_down</Icon>;
      }
      title = get(props, 'superset.name', '');
      subtitle = get(props, 'report_section.title', null);
    } else if (collectionName === 'realm-images') {
      mergeKeysIntoRealm(props);
      icon = getRealmIcon(props.realm);
      title = getRealmName(props, 'N/A', true);
      subtitle = get(props, 'superset.name', null);
    } else if (collectionName === 'comment-images') {
      icon = <Icon>chat_bubble</Icon>;
      title = get(props, 'name') || 'Comment image';
      subtitle = null;
    } else if (collectionName === 'task-images') {
      icon = <Icon>library_add_check</Icon>;
      title = get(props, 'task.name', 'N/A');
      subtitle = get(props, 'task.description', 'N/A');
    } else {
      return null;
    }

    return (
      <div className="data">
        <div className={classes.row}>
          <div className="iconWrap">{icon}</div>
          <div className="title">{title}</div>
        </div>
        {subtitle && <div className="subtitle">{subtitle}</div>}
      </div>
    );
  };

  return (
    <div className={classes.photo}>
      <Media {...props} alwaysUseImageId overlay={renderData} showLink viewOnly outerContainerStyle={{ width: '100%', height: '100%' }} style={{ width: '100%', height: '100%' }} />
    </div>
  );
};

const isHighlight = (collectionName) => {
  return collectionName === 'highlights' || collectionName === 'report-section-bp-images' || collectionName === 'report-section-site-images';
};

const DataRetriever = (props) => {
  const { collectionName, scorecard_score, task, assessment } = props;
  const [params, setParams] = useState([{ url: '/' }, { waitFor: null }]);
  const [addData, setAddData] = useState({});
  const [loading, setLoading] = useState(false);

  const getMore = async (data, key) => {
    try {
      setLoading(true);

      if (key === 'processedScorecardScoreValues') {
        const resp = await sendData(
          {
            url: `/processed-scorecard-score-values`,
          },
          {
            normalize: {
              build: [key],
            },
            params: {
              filter: {
                scorecard_id: data.scorecardId,
                assessment_id: data.assessmentId,
              },
              include: 'superset,assessment',
            },
          }
        );
        const found = resp.find((f) => f.scorecardScoreId == scorecard_score.id);
        setAddData((d) => ({ ...d, [key]: found }));
      } else if (key === 'scorecards') {
        const resp = await sendData(
          {
            url: `/scorecards/${data.scorecardId}`,
          },
          {
            normalize: {
              build: [key],
            },
          }
        );
        setAddData((d) => ({ ...d, [key]: first(resp) }));
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let obj1 = {},
      obj2 = {};

    if (collectionName === 'scorecard-score-images') {
      obj1 = { url: `/scorecard-scores/${scorecard_score.id}` };
      obj2 = { build: ['scorecardScores'], transformData: (d) => first(d) };
    } else if (collectionName === 'task-images') {
      obj1 = { url: `/tasks/${task.id}` };
      obj2 = {
        build: ['tasks'],
        transformData: (d) => first(d),
        params: {
          include: 'authors',
        },
      };
    } else if (isHighlight(collectionName)) {
      obj1 = { url: `/report-sections/${get(props, 'report_section.id', props.id)}` };
      obj2 = {
        build: ['reportSections'],
        transformData: (d) => first(d),
        params: {
          include: 'user,assessment,images,superset',
        },
      };
    } else if (collectionName === 'realm-images') {
      const aid = get(assessment, 'id');
      obj1 = { url: `/assessments/${aid}` };
      obj2 = {
        build: ['assessments'],
        transformData: (d) => first(d),
        params: {
          include: 'realm,authors', //superset
        },
      };
    }

    if (obj1 || obj2) {
      setParams([obj1, obj2]);
    }
    setAddData({});
  }, [props]);

  const ret = useRetrieveData(...params);

  useEffect(() => {
    if (ret.data && !ret.loading) {
      if (collectionName === 'scorecard-score-images') {
        getMore(ret.data, 'scorecards');
      }
    }
  }, [ret.data, ret.loading, props]);

  return {
    ...ret,
    data: {
      ...ret.data,
      addData,
    },
    loading: ret.loading || loading,
  };
};

export const ImageCaption = (props) => {
  const { collectionName, scorecard_score, task } = props;
  const { isMobileXS } = useScreen();
  const [showAll, setShowAll] = useState(!isMobileXS);

  const classes = rowStyles({ isMobile: isMobileXS });

  const { data, loading, update } = DataRetriever(props);

  const [createModal, setCreateModal] = useState({
    open: false,
  });

  const selectLink = () => {
    let link = '';
    if (collectionName === 'scorecard-score-images') {
      link = `/reports/assessment/${get(data, 'assessmentId')}/scores`;
    } else if (collectionName === 'task-images' || collectionName === 'comment-images') {
      link = `/tasks/detail/${task.id}`;
    } else if (isHighlight(collectionName)) {
      link = `/reports/assessment/${get(props, 'assessment.id')}/highlights`;
    } else if (collectionName === 'realm-images') {
      link = `/reports/assessment/${get(props, 'assessment.id')}/photos`;
    }

    if (!link) {
      return alert('TODO');
    }

    window.open(link, '_blank');
  };

  const onClickHl = () => {
    const isTemplate = !get(props, 'assessment.id');
    setCreateModal((c) => ({
      ...c,
      open: true,
      isTemplate,
      canShowClone: false,
      isEdit: isTemplate ? true : false,
      assessment: data.assessment,
      highlight: data,
      onClose: () => {
        setCreateModal((c) => ({ ...c, open: false }));
        update();
      },
    }));
  };

  const header = () => {
    let headRow = [];

    if (collectionName === 'scorecard-score-images') {
      headRow = [
        { text: `${get(props, 'superset.name', '')}: ${get(props, 'checklist.name', 'N/A')}` },
        { text: get(props, 'user.name', 'N/A') },
        { text: get(props, 'createdAt') ? moment(get(props, 'createdAt')).format('L') : null },
      ];
    } else if (collectionName === 'task-images') {
      headRow = [{ text: get(data, 'name') }, { text: get(data, 'authors.0.name') }, { text: get(data, 'createdAt') ? moment(get(data, 'createdAt')).format('L') : null }];
    } else if (isHighlight(collectionName)) {
      const superset = get(data, 'superset.name', '');
      headRow = [
        { text: `${superset ? superset + ': ' : ''}${get(data, 'title', get(props, 'title', ''))}`, onClick: onClickHl },
        { text: get(data, 'user.name') },
        { text: get(data, 'createdAt') ? moment(get(data, 'createdAt')).format('L') : null },
      ];
    } else if (collectionName === 'realm-images') {
      mergeKeysIntoRealm(props);
      headRow = [{ text: get(props, 'realm.name', 'N/A') }, { text: get(data, 'authors.0.name') }, { text: get(props, 'createdAt') ? moment(get(props, 'createdAt')).format('L') : null }];
    } else if (collectionName === 'comment-images') {
      headRow = [{ text: get(props, 'task.name', 'N/A') }, { text: get(props, 'user.name') }, { text: get(props, 'createdAt') ? moment(get(props, 'createdAt')).format('L') : null }];
    }

    headRow = headRow.filter((r) => r.text);

    return (
      <div className={clsx(classes.row, 'headerRow')}>
        {headRow.map((hr, i) => {
          return (
            <span key={i}>
              <span className={hr.onClick ? 'link' : ''} onClick={hr.onClick}>
                {hr.text}
              </span>
              {!isMobileXS && i < headRow.length - 1 && <span className={classes.spacer}>{'-'}</span>}
            </span>
          );
        })}
      </div>
    );
  };

  const description = () => {
    let content = get(props, 'custom_properties.caption', get(props, 'customProperties.caption', null));

    if (collectionName === 'scorecard-score-images') {
      content = (
        <div className={classes.row}>
          {getDisplayValue({ value: get(data, 'score', null) }, get(data, 'addData.scorecards.config', null))}
          <ScoreIcon {...scorecard_score} />
          {`${get(data, 'checkpoint.name', 'N/A')}: ${get(data, 'checkpoint.description')}`}
        </div>
      );
    } else if (collectionName === 'task-images') {
      content = `${get(data, 'description') || ''}${content ? `: ${content}` : ''}`;
    } else if (isHighlight(collectionName)) {
      const isBp = get(data, 'sectionType') === 'Best Practices';

      content = (
        <>
          {`Quality Type: ${isBp ? 'Best Practice' : 'Quality Opportunity'}`}
          <div dangerouslySetInnerHTML={{ __html: isBp ? get(data, 'bpBody', 'N/A') : get(data, 'body', 'N/A') }} />
        </>
      );
    } else if (collectionName === 'realm-images') {
      content = get(props, 'superset.name', null);
    } else if (collectionName === 'comment-images') {
      content = get(props, 'comment.body', null) || content;
    }

    const ret = <div className={'description'}>{content}</div>;

    if (isMobileXS) {
      return (
        <div className={classes.mobileDescriptContainer}>
          {showAll && ret}
          <div className={clsx(classes.row, classes.centerrow, classes.mobileButtonRow)}>
            <Button size="small" variant="contained" color="primary" onClick={() => setShowAll(!showAll)}>
              {showAll ? 'LESS' : 'MORE'}
            </Button>
          </div>
        </div>
      );
    }

    return ret;
  };

  return (
    <div className={classes.captionContainer}>
      {header()}

      {loading ? (
        <Loader style={{ color: 'white', margin: 10 }} />
      ) : (
        <div>
          <div className="link small" onClick={selectLink}>
            Open Reference
          </div>

          {description()}
        </div>
      )}

      <CreateModal {...createModal} />
    </div>
  );
};

export const HLRow = (props) => {
  const { imageSize, item, canSelect, selected } = props;
  const [loading, setLoading] = useState(false);
  const [imageopen, setimageopen] = useState(false);
  const [createModal, setCreateModal] = useState({
    open: false,
  });
  const { isMobileXS } = useScreen();

  const classes = rowStyles({ imageSize, isMobile: isMobileXS, canSelect });

  const clickRow = async () => {
    try {
      if (canSelect || imageopen) {
        return;
      }
      setLoading(true);
      const data = first(
        await sendData(
          { url: `/report-sections/${item.id}` },
          {
            normalize: {
              build: ['reportSections'],
            },
            params: {
              include: 'superset,user,assessment,images',
            },
          }
        )
      );
      const isTemplate = !get(item, 'assessment.id');
      setCreateModal((c) => ({
        ...c,
        open: true,
        isEdit: isTemplate ? true : false,
        canShowClone: false,
        assessment: data.assessment,
        isTemplate,
        highlight: data,
        onClose: () => {
          setCreateModal((c) => ({ ...c, open: false }));
        },
      }));
    } catch (err) {
      alert(err);
    } finally {
      setLoading(false);
    }
  };

  const fixImages = () => {
    return get(item, 'images', []).map((img) => ({
      ...item,
      ...img,
      realm: item.realm || { name: 'Template' },
      authors: item.realm ? undefined : [item.user],
      canSelect,
      onOpen: () => {
        setimageopen(true);
      },
      onClose: (s) => {
        setimageopen(false);
        item.onClose && item.onClose(s);
      },
      selectImage: () => {
        item.selectImage && item.selectImage(img);
      },
      imageSel: !!get(selected, img.id),
      showLink: true,
    }));
  };

  const hasRealm = get(item, 'realm.id');
  if (hasRealm) {
    mergeKeysIntoRealm(item);
  }

  return (
    <>
      <div onClick={clickRow} className={clsx(classes.row, classes.hlRow)}>
        <div className={'hlRow'}>
          <div className="title">{get(item, 'title', 'Title')}</div>
          <div>{get(item, 'superset.title', 'N/A')}</div>
          <div className={!hasRealm ? 'templateTitle' : ''}>{hasRealm ? getRealmName(item, 'N/A', true) : 'Template'}</div>
          <div>{`Created: ${moment(get(item, 'createdAt')).format('L')}`}</div>
          <div>{`Author: ${get(item, 'user.name', get(item, 'user_id', 'N/A'))}`}</div>
        </div>

        <div className="imageListContainer">
          <ImageList spaceBetween={3} images={fixImages()} />
        </div>

        {loading && (
          <div className="loadingMask">
            <Loader style={{ color: 'white' }} />
          </div>
        )}
      </div>

      <CreateModal {...createModal} />
    </>
  );
};

export const PhotoRow = (props) => {
  const { data, item, selectedOption, COLUMNS, contSize, selected } = props;

  const containerSize = get(contSize, `entries.0.target.offsetWidth`) - COLUMNS * 8;
  const imageSize = containerSize ? (containerSize - COLUMNS * 3) / COLUMNS : null;

  if (selectedOption.id === 'highlights') {
    return <HLRow {...props} imageSize={imageSize} />;
  }

  return <Photo key={item.id} images={data} {...item} imageSel={!!get(selected, item.id)} imageSize={imageSize} />;
};
